import { CardDataType, type CardData, ComponentName } from "../types";

export class FiltersVodCardData implements CardData {

        private itemClass: string;
        private caption: string | null;
        private index: number;
        public type: string;

    constructor(itemClass: string, caption: string | null, index: number, type: string,) { 
        this.itemClass = itemClass;
        this.caption = caption;
        this.index = index;
        this.type = type;

    }

    getId(): string {
        return `${this.index}`;
    }

    getClass(): string {
        return this.itemClass;
    }

    getType(): CardDataType {
        return CardDataType.FiltersVod;
    }

    getComponentName() {
        return ComponentName.FILTERS_VOD;
    }

    getCaption(): string | null {
        return this.caption;
    }

    getFilterType(): string {
        return this.type;
    }
}